var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import { SwitchStyled, SwitchCircleStyled } from './styled';
const Switch = (_a) => {
    var { checked, onChange } = _a, props = __rest(_a, ["checked", "onChange"]);
    const [checkedState, setCheckedState] = useState(checked);
    const { small, disabled } = props;
    const handleChange = (event) => {
        onChange(event);
        setCheckedState(!checkedState);
    };
    useEffect(() => {
        setCheckedState(checked);
    }, [checked]);
    return (_jsx(SwitchStyled, Object.assign({}, props, { checked: checkedState, onClick: handleChange }, { children: _jsx(SwitchCircleStyled, Object.assign({ disabled: disabled, small: small, checked: checkedState }, { children: _jsx("span", { id: "drawIcon" }) })) })));
};
Switch.defaultProps = {
    checked: false,
    onChange: () => { },
};
export default Switch;
//# sourceMappingURL=index.js.map